import React from 'react'
import { observer } from '~/common/mobx.decorator'
import { useUtmTracking } from '~/hooks/use-utm-tracking'
import { utmTrackingStore } from './utm-tracking.store'
import { useLocation } from 'react-router-dom'
import { Backdrop, CircularProgress } from '@material-ui/core'

export const UtmTrackingFeature = observer(() => {
	const location = useLocation()

	// Pass location to hook instead of using useLocation inside hook
	useUtmTracking(location)

	if (!utmTrackingStore.loading) return null

	return (
		<Backdrop open={true} style={{ zIndex: 9999, color: '#fff' }}>
			<CircularProgress color="inherit" />
		</Backdrop>
	)
})

export default UtmTrackingFeature
